import { StyleRulesCallback } from '@material-ui/core';

export type StyleKeys = 'paperWidthMd';

export const styles: StyleRulesCallback<StyleKeys> = () => ({
  paperWidthMd: {
    width: '370px',
  },
});
